var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "diagram-viewer",
      class: { "is-grabbing": _vm.mousePressed },
      on: {
        wheel: _vm.handleWheel,
        mousemove: _vm.handleMove,
        mousedown: function ($event) {
          _vm.mousePressed = true
        },
        mouseup: function ($event) {
          _vm.mousePressed = false
        },
      },
    },
    [
      _c(
        "div",
        { ref: "wrapperEl", staticClass: "wrapper" },
        [
          _c("BlockConnectors", {
            attrs: { blocks: _vm.blocks.blocks, metas: _vm.blocks.metas },
          }),
          _vm._v(" "),
          _vm._l(_vm.blocks.blocks, function (block) {
            return _c("Block", {
              key: block.id,
              attrs: {
                block: block,
                metas: _vm.blocks.metas,
                active: _vm.selectedBlock === block.id,
                automation: _vm.automation,
                flattedDiagram: _vm.flattedDiagram,
                movingMode: _vm.movingMode,
                movingBlock: _vm.movingBlock,
                changeMoveMode: _vm.changeMoveMode,
                moveBlock: _vm.moveBlock,
                copyingMode: _vm.copyingMode,
                copyingBlock: _vm.copyingBlock,
                changeCopyMode: _vm.changeCopyMode,
                copyBlock: _vm.copyBlock,
                showNotification: _vm.showNotification,
                dragMode: _vm.dragMode,
                addBlockToDiagram: _vm.addBlockToDiagram,
                draggingType: _vm.draggingType,
                collapsed: false,
                collapsedAll: false,
                "start-test-from-here": _vm.startTestFromHere,
                selected: _vm.selectedBlockId === block.id,
                "preview-mode": _vm.previewMode,
                getAllowedBlocks: _vm.getAllowedBlocks,
              },
              on: {
                openContextMenu: function (e) {
                  return _vm.$emit("openContextMenu", e)
                },
                focusBlock: _vm.focusBlock,
                updateAutomation: function ($event) {
                  return _vm.$emit("updateAutomation", $event)
                },
              },
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.minimapVisible && _vm.blocks.blocks.length > 5
        ? _c("div", { staticClass: "automation-minimap-container" }, [
            _c(
              "div",
              {
                staticClass: "automation-minimap-content",
                on: { click: _vm.onMinimapClick },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: _vm.minimapWidth,
                      height: _vm.minimapHeight,
                    },
                  },
                  [
                    _c(
                      "defs",
                      [
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-start",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#10b981",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#059669",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-flow",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#8b5cf6",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#7c3aed",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-message",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#3b82f6",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#2563eb",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-input",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#f59e0b",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#d97706",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-attachment",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#f97316",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#ea580c",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-condition",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#ef4444",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#dc2626",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-success",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#22c55e",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#16a34a",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-failure",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#f87171",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#ef4444",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-fallback",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#94a3b8",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#64748b",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-transfer",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#ec4899",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#db2777",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              id: "automation-gradient-default",
                              x1: "0%",
                              y1: "0%",
                              x2: "100%",
                              y2: "100%",
                            },
                          },
                          [
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#9ca3af",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "0%" },
                            }),
                            _vm._v(" "),
                            _c("stop", {
                              staticStyle: {
                                "stop-color": "#6b7280",
                                "stop-opacity": "1",
                              },
                              attrs: { offset: "100%" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.blocks.blocks, function (block) {
                      return _c("rect", {
                        key: "automation-minimap-" + block.id,
                        class: [
                          "automation-minimap-block",
                          {
                            "automation-selected":
                              _vm.selectedBlockId === block.id,
                          },
                        ],
                        attrs: {
                          x: _vm.getMinimapX(_vm.blocks.metas[block.id].x),
                          y: _vm.getMinimapY(_vm.blocks.metas[block.id].y),
                          width: _vm.getMinimapWidth(
                            _vm.blocks.metas[block.id].width
                          ),
                          height: _vm.getMinimapHeight(
                            _vm.blocks.metas[block.id].height
                          ),
                          fill: _vm.getBlockColor(block.type),
                          rx: "2",
                          ry: "2",
                        },
                      })
                    }),
                    _vm._v(" "),
                    _c("rect", {
                      staticClass: "automation-minimap-viewport",
                      attrs: {
                        x: _vm.viewportX,
                        y: _vm.viewportY,
                        width: _vm.viewportWidth,
                        height: _vm.viewportHeight,
                        fill: "rgba(59, 130, 246, 0.1)",
                        stroke: "#3b82f6",
                        "stroke-width": "2",
                        "stroke-dasharray": "4,2",
                        rx: "6",
                        ry: "6",
                      },
                    }),
                  ],
                  2
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }